<ub-card [rounded]="true">
    <h3 class="t-upper t-weight--normal" title>
        {{ $title() }}
    </h3>
    <div content>
        <eas-interactive-table [options]="tableComponentOptions"></eas-interactive-table>
    </div>
</ub-card>
